/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Authorized_MessageInputs */

const en_not_authorized_message = /** @type {(inputs: Not_Authorized_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to view this page. If you believe this is an error, contact your administrator and request access.`)
};

const nl_not_authorized_message = /** @type {(inputs: Not_Authorized_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt geen toestemming om deze pagina te bekijken. Als je denkt dat dit een fout is, neem dan contact op met je beheerder en vraag om toegang.`)
};

/**
* | output |
* | --- |
* | "You don't have permission to view this page. If you believe this is an error, contact your administrator and request access." |
*
* @param {Not_Authorized_MessageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const not_authorized_message = /** @type {((inputs?: Not_Authorized_MessageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Authorized_MessageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_not_authorized_message(inputs)
	return en_not_authorized_message(inputs)
});